import axios from 'axios'

// 获取当前活跃的广告
export function getActiveAdvertisement() {
  return axios({
    url: 'http://localhost:8085/system/advertisement/active',
    method: 'get'
  })
}

// 记录广告操作日志
export function logAdvertisementAction(data) {
  return axios({
    url: 'http://localhost:8085/system/advertisement/log',
    method: 'post',
    data: data
  })
} 